// extracted by mini-css-extract-plugin
module.exports = {"image":"HashAvatar-module__image___3nvco"};